import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from '@environment/environment';
import { LoadingService } from '@core/services/loading/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const canShowLoader = !!request.url.startsWith(environment.apiBasePath);

    if (canShowLoader) {
      this.loadingService.show();
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (canShowLoader) {
          this.loadingService.hide();
        }
      })
    );
  }
}
